import { Stack } from "@mui/material";
import type { FC } from "react";
import type { TimelineSectionProps } from "web_myplann/NotificationCenter/Types/TimelineSectionProps";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";

export const TimelineSectionV2Frame: FC<TimelineSectionProps> = ({
	title,
	muted = false,
	testId,
	children,
}) => (
	<Stack data-testid={testId}>
		<SectionHeader title={title} muted={muted} />
		<Stack bgcolor="background.paper">{children}</Stack>
	</Stack>
);
